/**
 * useSectionSetup — consolidates the 5-8 lines of common setup logic
 * repeated across every landing section component.
 *
 * Usage:
 *   const { s, ref, visible, anim, config, content } = useSectionSetup(block, {
 *       primaryColor, secondaryColor, enableAnimations, mediaFolders,
 *   });
 *
 * Returns:
 *   s       — object from sectionStyles() with bg, bgStyle, text, textSub, accent, secondary,
 *             dark, padClass, maxWidth, radiusClass, shadowClass
 *   ref     — ref to attach to the animated container (from useScrollReveal)
 *   visible — boolean, true once the element has scrolled into view
 *   anim    — className string for the scroll-reveal transition
 *   config  — block.config (defaults to {})
 *   content — block.content (defaults to {})
 */
import { sectionStyles, getAnimation } from '../utils';
import useScrollReveal from '../useScrollReveal';

export default function useSectionSetup(block = {}, { primaryColor, secondaryColor, enableAnimations, mediaFolders } = {}) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor, mediaFolders);
    const [ref, visible] = useScrollReveal(0.15, !enableAnimations);
    const anim = getAnimation(config, visible);
    return { s, ref, visible, anim, config, content };
}
